/* Shared behavior for the two standalone COD test pages: page-cod-upsell and page-cod-confirm.
   Each page only runs the block relevant to it (guarded by checking its own root element exists).

   Both pages read/write a small sessionStorage record (PCO_SESSION_KEY) instead of Shopify's
   real cart -- this COD/Bank Transfer test funnel is deliberately isolated from whatever the
   customer already has in their regular cart, in both directions: their existing cart is never
   read into this order, and this order never touches their existing cart. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  var PCO_SESSION_KEY = 'pco_session_v1';

  // Free "หน้ากากตา" (sleeping/eye mask) gift: one per pillow sold, across the front-end
  // tier AND the accepted upsell tier combined (e.g. 4 front-end + 2 upsell = 6 masks).
  // Already ฿0 on Shopify (silk-sleeping-mask / SLEEPMASK-SLK) -- just added as its own
  // zero-priced line item on the REAL order, so it shows up on the order/packing slip.
  var FREE_MASK_VARIANT_ID = '42610235867241';
  var FREE_MASK_TITLE = 'หน้ากากตา (ฟรี)';
  var FREE_MASK_IMAGE = 'https://cdn.shopify.com/s/files/1/0653/3375/6009/files/Premium-Mask_363dfcce-3f14-406c-a54c-d36a74611a5e.webp?v=1760061629';
  var FREE_LABEL = 'ฟรี';

  function pcoLoadSession() {
    try {
      var raw = sessionStorage.getItem(PCO_SESSION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function pcoSaveSession(session) {
    try { sessionStorage.setItem(PCO_SESSION_KEY, JSON.stringify(session)); } catch (e) { /* noop */ }
  }

  function formatMoneyDecimal(amountStr, currency) {
    var amount = Math.round(parseFloat(amountStr || '0'));
    var formatted = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var symbol = (!currency || currency === 'THB') ? '฿' : (currency + ' ');
    return symbol + formatted;
  }

  function formatBaht(amount) {
    return '฿' + Math.round(amount || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function parseBaht(str) {
    var digits = String(str || '').replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function capitalize(word) {
    if (!word) return '';
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // ---------------------------------------------------------------------
  // page-cod-upsell: the post-purchase one-time-offer page
  // ---------------------------------------------------------------------
  function initUpsellPage() {
    var page = document.getElementById('pco-upsell-page');
    if (!page) return;

    var headingEl = document.getElementById('pco-upsell-heading');
    var timerBarEl = document.getElementById('pco-upsell-timerbar');
    var qtyList = document.getElementById('pco-upsell-qty-list');
    var qtyItems = qtyList ? Array.prototype.slice.call(qtyList.querySelectorAll('.pco-upsell-qty-item')) : [];
    var priceStrikeEl = document.getElementById('pco-upsell-price-strike');
    var priceNowEl = document.getElementById('pco-upsell-price-now');
    var saveBadgeEl = document.getElementById('pco-upsell-save-badge');
    var ctaBtn = document.getElementById('pco-upsell-cta');
    var noThanksBtns = Array.prototype.slice.call(document.querySelectorAll('.pco-upsell-no-thanks'));
    var variantId = page.getAttribute('data-variant-id');
    var offerTitle = page.getAttribute('data-product-title') || 'Item';
    var offerImage = page.getAttribute('data-product-image') || '';
    var confirmUrl = page.getAttribute('data-confirm-url') || (root + 'pages/cod-order-confirmation');
    // 'primary' (default): the offer is recorded as session.upsell (pillow/seat pages).
    // 'extra': a second offer page (e.g. seat + ARC after the pillow upsell); recorded in
    // session.extraUpsells[] so it never overwrites the first one. data-extra-role says how
    // the Worker prices/gifts the main line: 'upsell' (flat rate + free mask) or 'upsellAddon'.
    var upsellSlot = page.getAttribute('data-upsell-slot') || 'primary';
    var extraRole = page.getAttribute('data-extra-role') || 'upsell';
    var selectedTier = null;

    function applyTier(item) {
      if (!item) return;
      qtyItems.forEach(function (x) { x.classList.remove('sel'); });
      item.classList.add('sel');
      selectedTier = {
        qty: item.getAttribute('data-qty') || '1',
        price: item.getAttribute('data-price') || '',
        strike: item.getAttribute('data-strike') || '',
        save: item.getAttribute('data-save') || ''
      };
      if (priceStrikeEl) priceStrikeEl.textContent = selectedTier.strike;
      if (priceNowEl) priceNowEl.textContent = selectedTier.price;
      if (saveBadgeEl) { saveBadgeEl.textContent = selectedTier.save; saveBadgeEl.style.display = selectedTier.save ? '' : 'none'; }
      renderAddLine();
    }

    qtyItems.forEach(function (item) { item.addEventListener('click', function () { applyTier(item); }); });
    applyTier(qtyList ? (qtyList.querySelector('.pco-upsell-qty-item.sel') || qtyItems[0]) : null);

    // Personalize heading with the customer's first name, read from this funnel's own
    // session record (set on the PDP form) rather than the real Shopify cart.
    var initSession = pcoLoadSession();

    // Upsell split test (4 Oct 2026). A = red decline link + a line saying how much the
    // offer ADDS to the amount they already owe; B = red decline link only. The arm is
    // normally assigned on the PDP (session.upsellVariant, mirrored into
    // cartAttributes.upsell_variant so it lands on the Shopify order as a custom attribute);
    // sessions that started before this shipped get assigned here instead.
    var uv = (initSession && initSession.upsellVariant) || '';
    if (!uv) {
      uv = (Math.random() < 0.5) ? 'A' : 'B';
      if (initSession) {
        initSession.upsellVariant = uv;
        initSession.cartAttributes = initSession.cartAttributes || {};
        initSession.cartAttributes.upsell_variant = uv;
        pcoSaveSession(initSession);
      }
    }
    // Preview only: ?uv=A or ?uv=B forces the arm for this page load (not saved to the session).
    var forcedUv = (window.location.search.match(/[?&]uv=(A|B)\b/) || [])[1];
    if (forcedUv) uv = forcedUv;
    page.classList.add('pco-uv-' + uv);
    var addLineEl = document.getElementById('pco-upsell-addline');
    var isBankSession = !!(initSession && initSession.paymentMethod === 'Bank Transfer');
    function renderAddLine() {
      if (!addLineEl || uv !== 'A' || !selectedTier) return;
      var amt = parseBaht(selectedTier.price);
      if (!amt) { addLineEl.hidden = true; return; }
      addLineEl.textContent = (isBankSession ? 'ยอดโอนชำระจะเพิ่มขึ้นอีก ' : 'ยอดชำระปลายทางจะเพิ่มขึ้นอีก ') + formatBaht(amt) + ' จากยอดคำสั่งซื้อเดิม';
      addLineEl.hidden = false;
    }
    renderAddLine();
    var fullName = (initSession && initSession.customer && initSession.customer.fullName) || '';
    var firstName = fullName ? capitalize(fullName.trim().split(/\s+/)[0]) : '';
    if (headingEl) {
      var tmpl = headingEl.getAttribute('data-template') || headingEl.textContent;
      var replaced = tmpl.indexOf('{first_name}') !== -1 ? tmpl.replace('{first_name}', firstName) : tmpl;
      headingEl.textContent = replaced.replace(/^\s+/, '');
    }

    // Countdown timer (visual urgency only, doesn't block the offer on expiry). {timer} inside
    // the configured line is replaced every second with the live mm:ss remaining, wrapped in a
    // span so the digits can be styled (yellow) separately from the rest of the line.
    if (timerBarEl) {
      var timerTmpl = timerBarEl.getAttribute('data-template') || timerBarEl.textContent;
      var timerTmplSafe = escapeHtml(timerTmpl);
      var mins = parseInt(page.getAttribute('data-timer-minutes'), 10) || 5;
      var remaining = mins * 60;
      function renderTimer() {
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        var timeStr = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
        var timeHtml = '<span class="pco-upsell-timer-num">' + timeStr + '</span>';
        timerBarEl.innerHTML = timerTmplSafe.indexOf('{timer}') !== -1 ? timerTmplSafe.replace('{timer}', timeHtml) : timerTmplSafe;
      }
      renderTimer();
      var interval = setInterval(function () {
        remaining--;
        if (remaining < 0) { clearInterval(interval); return; }
        renderTimer();
      }, 1000);
    }

    function goToConfirm() { window.location.href = confirmUrl; }

    noThanksBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); goToConfirm(); }); });

    // Optional add-on rows under the tiers (schema block type "addon" in
    // page-cod-upsell.liquid, e.g. the ARC back cushion on the MAX seat upsell).
    // Each row: checkbox + qty select; data attributes carry variant/title/image.
    var addonRows = Array.prototype.slice.call(page.querySelectorAll('.pco-upsell-addon'));
    var addonState = addonRows.map(function () { return { checked: false, qty: 1 }; });
    addonRows.forEach(function (row, i) {
      var st = addonState[i];
      var max = Math.max(1, parseInt(row.getAttribute('data-max-qty'), 10) || 4);
      var check = row.querySelector('.pco-upsell-addon-check');
      var qval = row.querySelector('.pco-upsell-addon-qval');
      function paint() {
        row.classList.toggle('sel', st.checked);
        if (check) check.checked = st.checked;
        if (qval) qval.textContent = String(st.qty);
      }
      row.addEventListener('click', function (e) {
        if (e.target.closest('.pco-upsell-addon-qty')) return;
        if (e.target.closest('.pco-upsell-addon-checkwrap')) return; // label toggles natively; avoid double toggle
        st.checked = !st.checked;
        paint();
      });
      if (check) check.addEventListener('click', function (e) { e.stopPropagation(); st.checked = check.checked; paint(); });
      var minus = row.querySelector('.pco-upsell-addon-minus');
      var plus = row.querySelector('.pco-upsell-addon-plus');
      if (minus) minus.addEventListener('click', function (e) { e.stopPropagation(); if (st.qty > 1) st.qty -= 1; else st.checked = false; paint(); });
      if (plus) plus.addEventListener('click', function (e) { e.stopPropagation(); if (!st.checked) st.checked = true; if (st.qty < max) st.qty += 1; paint(); });
      paint();
    });
    function selectedUpsellAddons() {
      var out = [];
      addonRows.forEach(function (row, i) {
        if (!addonState[i].checked) return;
        out.push({
          variantId: row.getAttribute('data-variant-id') || '',
          productTitle: row.getAttribute('data-title') || '',
          image: row.getAttribute('data-image') || '',
          qty: addonState[i].qty,
          price: row.getAttribute('data-price') || '',
          strike: row.getAttribute('data-strike') || ''
        });
      });
      return out.filter(function (a) { return a.variantId; });
    }

    if (ctaBtn && variantId) {
      ctaBtn.addEventListener('click', function () {
        var tier = selectedTier || { qty: '1', price: '', strike: '', save: '' };
        var qty = parseInt(tier.qty, 10) || 1;

        // No fetch/cart mutation needed: just record the accepted upsell against this
        // funnel's own session (never the real cart) and move straight to confirm.
        var sess = pcoLoadSession() || {};
        if (upsellSlot === 'extra') {
          sess.extraUpsells = Array.isArray(sess.extraUpsells) ? sess.extraUpsells : [];
          // tier price/strike are TOTALS for the tier's quantity (same as the primary offer)
          sess.extraUpsells.push({ variantId: variantId, productTitle: offerTitle, image: offerImage, qty: qty, price: tier.price, strike: tier.strike, role: extraRole, isLineTotal: true });
          selectedUpsellAddons().forEach(function (a) {
            sess.extraUpsells.push({ variantId: a.variantId, productTitle: a.productTitle, image: a.image, qty: a.qty, price: a.price, strike: a.strike, role: 'upsellAddon' });
          });
          pcoSaveSession(sess);
          if (window.pcoRefreshReservation) window.pcoRefreshReservation(sess);
          goToConfirm();
          return;
        }
        sess.upsell = {
          variantId: variantId,
          productTitle: offerTitle,
          image: offerImage,
          qty: qty,
          price: tier.price,
          strike: tier.strike,
          save: tier.save,
          // Add-ons accepted together with the upsell (flat upsell price each, no gift).
          addons: selectedUpsellAddons(),
          accepted: true
        };
        pcoSaveSession(sess);
        if (window.pcoRefreshReservation) window.pcoRefreshReservation(sess);
        goToConfirm();
      });
    }
  }

  // ---------------------------------------------------------------------
  // page-cod-confirm: the order confirmation / payment instructions page
  // ---------------------------------------------------------------------
  function initConfirmPage() {
    var page = document.getElementById('pco-confirm-page');
    if (!page) return;

    var codBannerEl = document.getElementById('pco-cod-banner');
    var bankAlertEl = document.getElementById('pco-bank-alert');
    var bankCardEl = document.getElementById('pco-bank-card');
    var orderIdEl = document.getElementById('pco-confirm-order-id');
    var toggleTotalEl = document.getElementById('pco-order-summary-toggle-total');
    var amountEl = document.getElementById('pco-confirm-amount');
    var copyBtn = document.getElementById('pco-confirm-copy-btn');
    var copiedMsg = document.getElementById('pco-confirm-copied-msg');
    var acctNumEl = document.getElementById('pco-confirm-acct-num');
    var toggleBtn = document.getElementById('pco-order-summary-toggle');
    var summaryBody = document.getElementById('pco-order-summary-body');
    var itemsEl = document.getElementById('pco-order-items');
    var totalsEl = document.getElementById('pco-order-totals');
    var subtotalEl = document.getElementById('pco-order-subtotal');
    var discountRowEl = document.getElementById('pco-order-discount-row');
    var discountEl = document.getElementById('pco-order-discount');
    var grandTotalEl = document.getElementById('pco-order-total');
    var contactEl = document.getElementById('pco-detail-contact');
    var paymentMethodEl = document.getElementById('pco-detail-payment-method');
    var addressEl = document.getElementById('pco-detail-address');
    var workerUrl = page.getAttribute('data-worker-url');
    var paymentLabelCod = page.getAttribute('data-payment-label-cod') || 'Cash on Delivery';
    var paymentLabelBank = page.getAttribute('data-payment-label-bank') || 'Bank Transfer';

    if (toggleBtn && summaryBody) {
      toggleBtn.addEventListener('click', function () {
        var isOpen = summaryBody.classList.toggle('open');
        toggleBtn.classList.toggle('open', isOpen);
        toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function renderHeader(data) {
      if (orderIdEl) orderIdEl.textContent = data.orderId || '-';
      if (toggleTotalEl) toggleTotalEl.textContent = data.total || '-';
      if (amountEl) amountEl.textContent = data.total || '-';
    }

    // Payment method + contact + shipping address, all from this funnel's own session
    // (never the real cart). "Contact info" shows whichever of email/phone were captured --
    // both, if both were given, not just one.
    function renderDetails(session) {
      var customer = (session && session.customer) || {};
      var paymentMethod = (session && session.paymentMethod) || '';

      var isCod = paymentMethod === 'Cash on Delivery';
      var isBank = paymentMethod === 'Bank Transfer';
      if (codBannerEl) codBannerEl.style.display = isCod ? '' : 'none';
      if (bankAlertEl) bankAlertEl.style.display = isBank ? '' : 'none';
      if (bankCardEl) bankCardEl.style.display = isBank ? '' : 'none';

      if (paymentMethodEl) {
        paymentMethodEl.textContent = isCod ? paymentLabelCod : (isBank ? paymentLabelBank : (paymentMethod || '-'));
      }

      if (contactEl) {
        var contactLines = [];
        if (customer.email) contactLines.push(escapeHtml(customer.email));
        if (customer.phone) contactLines.push(escapeHtml(customer.phone));
        contactEl.innerHTML = contactLines.length ? contactLines.join('<br>') : '-';
      }

      if (addressEl) {
        var addrLines = [];
        if (customer.fullName) addrLines.push(escapeHtml(customer.fullName));
        if (customer.address) {
          var line = escapeHtml(customer.address);
          if (customer.zip) line += ', ' + escapeHtml(customer.zip);
          addrLines.push(line);
        }
        if (customer.phone) addrLines.push(escapeHtml(customer.phone));
        addressEl.innerHTML = addrLines.length ? addrLines.join('<br>') : '-';
      }
    }

    // Builds the itemized order-summary panel purely from this funnel's own session data
    // (the PDP item + accepted upsell, if any) -- never from the real Shopify cart, so a
    // customer's unrelated pre-existing cart items never show up or get billed here.
    //
    // NOTE on isLineTotal: the base PDP item's price/comparePrice are genuine PER-UNIT prices
    // (the PDP always adds quantity 1). The upsell item's price/strike, however, come straight
    // off the selected quantity-tier button (e.g. "qty 2 for ฿2,580") -- that's already the
    // TOTAL for the whole tier, not a per-unit price. Multiplying it by qty again (as this used
    // to do) silently doubled/quadrupled the upsell line and threw off the whole summary.
    // Base lines: one per distinct variant. Variant products (bedding, pdp-bedding-cod.js)
    // write session.bases = [{variantId, quantity, productTitle, image, price, comparePrice}];
    // the pillow/seat funnel writes the single legacy variantId/quantity pair.
    function sessionBases(session) {
      if (session && Array.isArray(session.bases) && session.bases.length) {
        return session.bases.filter(function (b) { return b && b.variantId; });
      }
      if (session && session.variantId) {
        return [{ variantId: session.variantId, quantity: session.quantity || 1, productTitle: session.productTitle || '', image: session.image || '', price: session.price, comparePrice: session.comparePrice }];
      }
      return [];
    }
    // Every post-purchase line in the order they are sent to the Worker: the primary offer
    // (session.upsell + its addons) then any extra offer pages (session.extraUpsells, each
    // with its own role). isLineTotal: tier prices on the pillow/seat pages are tier TOTALS.
    function sessionUpsellLines(session) {
      var out = [];
      if (session && session.upsell && session.upsell.accepted && session.upsell.variantId) {
        var u = session.upsell;
        out.push({ role: 'upsell', variantId: u.variantId, qty: u.qty || 1, productTitle: u.productTitle || '', image: u.image || '', price: u.price, strike: u.strike, isLineTotal: true });
        (u.addons || []).forEach(function (a) {
          if (a && a.variantId) out.push({ role: 'upsellAddon', variantId: a.variantId, qty: a.qty || 1, productTitle: a.productTitle || '', image: a.image || '', price: a.price, strike: a.strike, isLineTotal: false });
        });
      }
      ((session && session.extraUpsells) || []).forEach(function (x) {
        if (!x || !x.variantId) return;
        out.push({ role: x.role === 'upsellAddon' ? 'upsellAddon' : 'upsell', variantId: x.variantId, qty: x.qty || 1, productTitle: x.productTitle || '', image: x.image || '', price: x.price, strike: x.strike, isLineTotal: !!x.isLineTotal });
      });
      return out;
    }
    function sessionUpsellUnits(session) {
      var n = 0;
      sessionUpsellLines(session).forEach(function (l) { if (l.role === 'upsell') n += l.qty; });
      return n;
    }
    function sessionBaseUnits(session) {
      var n = 0;
      sessionBases(session).forEach(function (b) { n += (b.quantity || 1); });
      return n;
    }

    function buildLineItemsForDisplay(session) {
      var items = [];
      sessionBases(session).forEach(function (b) {
        items.push({
          title: b.productTitle || '',
          qty: b.quantity || 1,
          image: b.image || '',
          unitPrice: parseBaht(b.price),
          unitCompare: parseBaht(b.comparePrice),
          isLineTotal: false
        });
      });
      (session && session.addons || []).forEach(function (a) {
        items.push({ title: a.productTitle || '', qty: a.qty || 1, image: a.image || '', unitPrice: parseBaht(a.price), unitCompare: parseBaht(a.compare), isLineTotal: false });
      });
      sessionUpsellLines(session).forEach(function (l) {
        items.push({ title: l.productTitle, qty: l.qty, image: l.image, unitPrice: parseBaht(l.price), unitCompare: parseBaht(l.strike), isLineTotal: l.isLineTotal });
      });
      var giftPer = (session && session.gift && (session.gift.perUnit === 0 || session.gift.perUnit)) ? Number(session.gift.perUnit) : 1;
      var maskQty = (session && session.variantId) ? (sessionBaseUnits(session) + sessionUpsellUnits(session)) * giftPer : 0;
      if (maskQty > 0) {
        items.push({ title: FREE_MASK_TITLE, qty: maskQty, image: FREE_MASK_IMAGE, unitPrice: 0, unitCompare: 0, isLineTotal: true, free: true });
      }
      return items;
    }

    function renderItemRows(items) {
      var subtotal = 0;
      var total = 0;
      var html = '';
      items.forEach(function (item) {
        subtotal += item.lineOriginal;
        total += item.lineFinal;
        html += '<div class="pco-order-item">'
          + '<div class="pco-order-item-thumb">'
          + (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '">' : '')
          + '<span class="pco-order-item-qty">' + item.qty + '</span>'
          + '</div>'
          + '<div class="pco-order-item-info"><p class="pco-order-item-title">' + escapeHtml(item.title) + '</p></div>'
          + '<div class="pco-order-item-price">'
          + (item.lineOriginal > item.lineFinal ? '<span class="pco-order-item-price-strike">' + formatBaht(item.lineOriginal) + '</span>' : '')
          + '<span>' + (item.free ? FREE_LABEL : formatBaht(item.lineFinal)) + '</span>'
          + '</div>'
          + '</div>';
      });

      itemsEl.innerHTML = html;
      totalsEl.style.display = '';
      if (subtotalEl) subtotalEl.textContent = formatBaht(subtotal);
      var discount = subtotal - total;
      if (discount > 0) {
        if (discountRowEl) discountRowEl.style.display = '';
        if (discountEl) discountEl.textContent = '−' + formatBaht(discount);
      } else if (discountRowEl) {
        discountRowEl.style.display = 'none';
      }
      if (grandTotalEl) grandTotalEl.textContent = formatBaht(total);
      return total;
    }

    function renderOrderSummary(session) {
      var items = buildLineItemsForDisplay(session);
      if (!itemsEl || !totalsEl || items.length === 0) {
        if (totalsEl) totalsEl.style.display = 'none';
        return 0;
      }
      var displayItems = items.map(function (item) {
        var multiplier = item.isLineTotal ? 1 : item.qty;
        return {
          title: item.title,
          qty: item.qty,
          image: item.image,
          lineOriginal: (item.unitCompare > item.unitPrice ? item.unitCompare : item.unitPrice) * multiplier,
          lineFinal: item.unitPrice * multiplier,
          free: !!item.free
        };
      });
      return renderItemRows(displayItems);
    }

    // Replaces the naive client-side estimate above with the REAL numbers once
    // the worker responds. IMPORTANT: on the actual order, Shopify applies the
    // whole quantity-break discount as ONE order-level "Discounted" line (see
    // discountCode.itemFixedDiscountCode in the worker) -- each line item's own
    // originalUnitPriceSet/discountedUnitPriceSet stay identical (full price),
    // confirmed straight from real orders in Admin. So this does NOT try to
    // split the discount back across individual lines (that would show a
    // number that doesn't match the real order at all) -- it shows each line
    // at its real, undiscounted total (from lineBreakdown, the same pricing
    // call that priced the order) and subtracts the one real aggregate
    // discount amount once, exactly mirroring the real order's structure.
    // lineBreakdown is matched by POSITION, not by variant id. Matching by variant id
    // (an earlier version of this code did that) breaks whenever the upsell offers the
    // SAME product as the base line -- which it normally does here (upsell is just "buy
    // more pillows") -- because both entries then share one key and the second silently
    // overwrites the first, making both rows show identical (wrong) numbers. We build the
    // lineItems array sent to the Worker ourselves in a fixed order (base first, then the
    // upsell line if accepted, then the free-mask line), and the Worker's lineBreakdown is
    // built by mapping over that same array in order (see fetchStorefrontPricing in the
    // Worker), so index 0 is always the base line and index 1 is the upsell line whenever
    // one was sent -- regardless of whether they happen to be the same variant.
    function renderOrderSummaryFromBreakdown(session, lineBreakdown, discountTotal) {
      if (!itemsEl || !totalsEl || !Array.isArray(lineBreakdown) || lineBreakdown.length === 0) return;

      var hasUpsell = !!(session && session.upsell && session.upsell.accepted && session.upsell.variantId);

      // Each row shows its REAL discounted line total (catalog total struck through when a
      // discount applies): front-end line = live quantity-break price, upsell line = the flat
      // upsell rate, both straight from the Worker's lineBreakdown (see PRICING_RULES.md in
      // the Worker repo). Free masks are the last entry, always ฿0, qty = total pillows.
      var items = [];
      var hasRoles = lineBreakdown.every(function (b) { return b && b.role; });
      if (hasRoles) {
        // Role-based matching (Worker >= 2026-09-29): base, addon*, upsell, upsellAddon*, gift.
        // Titles/images come from the session in the same order the lines were sent.
        var addonIdx = 0, upsIdx = 0, upsAddonIdx = 0, baseIdx = 0;
        var bases = sessionBases(session);
        var upsLines = sessionUpsellLines(session);
        var upsMain = upsLines.filter(function (l) { return l.role === 'upsell'; });
        var upsAdd = upsLines.filter(function (l) { return l.role === 'upsellAddon'; });
        lineBreakdown.forEach(function (b) {
          var meta = null;
          if (b.role === 'base') { meta = bases[baseIdx++] || bases[0] || {}; meta = { title: meta.productTitle || session.productTitle || '', image: meta.image || session.image || '' }; }
          else if (b.role === 'addon') { meta = (session.addons || [])[addonIdx++] || {}; meta = { title: meta.productTitle || '', image: meta.image || '' }; }
          else if (b.role === 'upsell') { meta = upsMain[upsIdx++] || {}; meta = { title: meta.productTitle || '', image: meta.image || '' }; }
          else if (b.role === 'upsellAddon') { meta = upsAdd[upsAddonIdx++] || {}; meta = { title: meta.productTitle || '', image: meta.image || '' }; }
          else if (b.role === 'gift') meta = { title: FREE_MASK_TITLE, image: FREE_MASK_IMAGE, free: true };
          if (!meta) return;
          if (b.role === 'gift' && !(b.quantity > 0)) return;
          items.push({
            title: meta.title, qty: b.quantity, image: meta.image,
            lineOriginal: meta.free ? 0 : (parseFloat(b.originalTotal) || 0),
            lineFinal: meta.free ? 0 : (parseFloat(b.discountedTotal) || 0),
            free: !!meta.free
          });
        });
      } else {
      var base = lineBreakdown[0];
      if (session && session.variantId && base) {
        items.push({
          title: session.productTitle || '',
          qty: base.quantity,
          image: session.image || '',
          lineOriginal: parseFloat(base.originalTotal) || 0,
          lineFinal: parseFloat(base.discountedTotal) || 0
        });
      }
      var ups = hasUpsell ? lineBreakdown[1] : null;
      if (ups) {
        items.push({
          title: session.upsell.productTitle || '',
          qty: ups.quantity,
          image: session.upsell.image || '',
          lineOriginal: parseFloat(ups.originalTotal) || 0,
          lineFinal: parseFloat(ups.discountedTotal) || 0
        });
      }
      var mask = lineBreakdown[hasUpsell ? 2 : 1];
      if (mask && mask.quantity > 0) {
        items.push({
          title: FREE_MASK_TITLE,
          qty: mask.quantity,
          image: FREE_MASK_IMAGE,
          lineOriginal: 0,
          lineFinal: 0,
          free: true
        });
      }
      }
      if (items.length === 0) return;

      var subtotal = 0;
      var html = '';
      items.forEach(function (item) {
        subtotal += item.lineOriginal;
        html += '<div class="pco-order-item">'
          + '<div class="pco-order-item-thumb">'
          + (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '">' : '')
          + '<span class="pco-order-item-qty">' + item.qty + '</span>'
          + '</div>'
          + '<div class="pco-order-item-info"><p class="pco-order-item-title">' + escapeHtml(item.title) + '</p></div>'
          + '<div class="pco-order-item-price">'
          + (item.lineOriginal > item.lineFinal ? '<span class="pco-order-item-price-strike">' + formatBaht(item.lineOriginal) + '</span>' : '')
          + '<span>' + (item.free ? FREE_LABEL : formatBaht(item.lineFinal)) + '</span>'
          + '</div>'
          + '</div>';
      });

      itemsEl.innerHTML = html;
      totalsEl.style.display = '';
      if (subtotalEl) subtotalEl.textContent = formatBaht(subtotal);
      var discount = parseFloat(discountTotal) || 0;
      if (discount > 0) {
        if (discountRowEl) discountRowEl.style.display = '';
        if (discountEl) discountEl.textContent = '−' + formatBaht(discount);
      } else if (discountRowEl) {
        discountRowEl.style.display = 'none';
      }
      if (grandTotalEl) grandTotalEl.textContent = formatBaht(subtotal - discount);
    }

    function fallbackToSessionEstimate(session, estimatedTotal, err) {
      var token = (session && session.token) || '';
      renderHeader({ orderId: token.slice(-8).toUpperCase(), total: formatBaht(estimatedTotal) });
      // Surface the REAL reason the Worker call failed (test funnel only). Without this the
      // failure was completely silent -- the page just showed the fake estimate above, with
      // no way to tell whether the order was actually created or why it wasn't.
      var msg = (err && (err.message || String(err))) || 'unknown error';
      // A bare "Failed to fetch" here almost always means the browser blocked the call on CORS:
      // the Worker only allows requests from https://ergolab.co (ALLOWED_ORIGIN in wrangler.toml),
      // so testing from the myshopify.com domain or www.ergolab.co silently kills every call.
      if (/failed to fetch|networkerror|load failed/i.test(msg)) {
        msg += ' (browser blocked the request -- page origin is ' + window.location.origin
          + ', but the Worker only accepts https://ergolab.co)';
      }
      if (window.console && console.error) console.error('[COD funnel] submit-cod-order failed, NO order was created:', msg);
      if (orderIdEl) {
        var dbg = document.createElement('p');
        dbg.style.cssText = 'color:#c00;font-size:12px;margin:6px 0 0;text-align:left;word-break:break-word;';
        dbg.textContent = '[TEST DEBUG] Order NOT created. Worker error: ' + msg;
        var host = orderIdEl.parentNode;
        if (host && host.parentNode) host.parentNode.insertBefore(dbg, host.nextSibling);
      }
    }

    var session = pcoLoadSession();
    renderDetails(session);
    var estimatedTotal = renderOrderSummary(session);

    // Quick preview shortcut for reviewing the design directly, independent of any session: ?preview=1
    if (/[?&]preview=1\b/.test(window.location.search)) {
      renderHeader({ orderId: 'PREVIEW1', total: '฿1,290' });
    } else if (!session || !session.variantId) {
      renderHeader({ orderId: '-', total: '-' });
    } else if (!workerUrl) {
      // No backend configured for this deploy: show our own session token as a stand-in.
      fallbackToSessionEstimate(session, estimatedTotal);
    } else {
      // Line order and roles are what the Worker echoes back (lineBreakdown[].role), and
      // what the summary panel renders by. Gift = 1 per base unit + 1 per upsell unit of the
      // main product (never for add-ons), configurable per product via session.gift.
      var gift = session.gift || { variantId: FREE_MASK_VARIANT_ID, perUnit: 1 };
      var giftPerUnit = (gift.perUnit === 0 || gift.perUnit) ? Number(gift.perUnit) : 1;
      var lineItems = sessionBases(session).map(function (b) { return { variantId: b.variantId, quantity: b.quantity || 1, role: 'base' }; });
      (session.addons || []).forEach(function (a) {
        if (a && a.variantId) lineItems.push({ variantId: a.variantId, quantity: a.qty || 1, role: 'addon' });
      });
      var maskQty = sessionBaseUnits(session) * giftPerUnit;
      // upsell:true tells the Worker to price these lines at the flat upsell rate and keep
      // them OUT of the quantity-break pricing cart (Shopify would merge them into the
      // front-end line and reprice everything at the combined tier -- see PRICING_RULES.md).
      // Primary offer first (+ its add-ons), then any extra offer pages, in order.
      sessionUpsellLines(session).forEach(function (l) {
        lineItems.push({ variantId: l.variantId, quantity: l.qty, upsell: true, role: l.role });
        if (l.role === 'upsell') maskQty += l.qty * giftPerUnit;
      });
      if (maskQty > 0) {
        lineItems.push({ variantId: gift.variantId || FREE_MASK_VARIANT_ID, quantity: maskQty, role: 'gift' });
      }

      // The funnel-chosen values (payment method + customer fields) always win over
      // whatever ad-attribution attrs happen to be sitting on the customer's real cart --
      // the worker reads Payment Method (and these other fields) from cartAttributes, so
      // sending only the raw ad-attribution attrs here (as before) let a stale/leftover
      // "Payment Method" from an unrelated earlier cart session silently override what the
      // customer actually picked. This mirrors the same attrs already sent
      // with the /reserve-cod-order call at PDP-submit time (see pdp-cod.js).
      var attrs = {};
      Object.keys(session.cartAttributes || {}).forEach(function (k) { attrs[k] = session.cartAttributes[k]; });
      attrs['Payment Method'] = session.paymentMethod || '';
      attrs['Full Name'] = (session.customer && session.customer.fullName) || '';
      attrs['Phone'] = (session.customer && session.customer.phone) || '';
      attrs['Email'] = (session.customer && session.customer.email) || '';
      attrs['Full Address'] = (session.customer && session.customer.address) || '';
      attrs['Zip Code'] = (session.customer && session.customer.zip) || '';

      var payload = {
        cartToken: session.token,
        lineItems: lineItems,
        customer: session.customer || {},
        cartAttributes: attrs
      };

      fetch(workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && res.j.error ? res.j.error : 'Order creation failed');
          renderHeader({ orderId: res.j.orderName, total: formatMoneyDecimal(res.j.total, res.j.currency) });
          renderOrderSummaryFromBreakdown(session, res.j.lineBreakdown, res.j.discountTotal);
        })
        .catch(function (err) {
          // Backend unreachable or errored: don't leave the page broken, fall back to our estimate.
          fallbackToSessionEstimate(session, estimatedTotal, err);
        });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var value = (copyBtn.getAttribute('data-account') || (acctNumEl ? acctNumEl.textContent : '')).replace(/\s|-/g, '');
        function showCopied() {
          copyBtn.classList.add('copied');
          if (copiedMsg) copiedMsg.classList.add('show');
          setTimeout(function () {
            copyBtn.classList.remove('copied');
            if (copiedMsg) copiedMsg.classList.remove('show');
          }, 1600);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(showCopied, function () { fallbackCopy(value, showCopied); });
        } else {
          fallbackCopy(value, showCopied);
        }
      });
    }

    function fallbackCopy(value, done) {
      var ta = document.createElement('textarea');
      ta.value = value;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* noop */ }
      document.body.removeChild(ta);
      done();
    }
  }

  function init() {
    initUpsellPage();
    initConfirmPage();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
